import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Read from "./Read";
import TabHome from "./TabHome";

interface HomeProps {}

interface HomeState {
    currentTab: number;
    tabIsTransitioning: boolean;
}

const Home = () => {
    const [currentTab, setCurrentTab] = useState(0);
    const navigate = useNavigate();

    const selectTabRead = () => {
        navigate("/page/0");
    };

    const selectTabHome = () => {
        navigate("/");
    };

    const formatTabContainer = () => {
        switch (currentTab) {
            default:
                return <TabHome selectTabRead={selectTabRead} />;

            case 0:
                return <TabHome selectTabRead={selectTabRead} />;
            case 1:
                return <Read selectTabHome={selectTabHome} />;
        }
    };

    return <>{formatTabContainer()}</>;
};

export default Home;
